import { remove } from 'diacritics';

const replaceSeveralSpacesWithOneSpace = (myString: string) => myString.replace(/\s\s+/g, ' ');

const getCleanName = (name?: string): string => {
  if (!name) {
    return '';
  }

  return remove(replaceSeveralSpacesWithOneSpace(name.toString().toUpperCase().trim().toUpperCase()));
};

export const getInitials = (name?: string): string | null => {
  if (!name) {
    return null;
  }

  const cleanName: string = getCleanName(name);

  const names = cleanName.split(' ');

  if (names.length === 1) {
    return cleanName[0];
  }

  const firstInitial = names[0][0];
  const lastInitial = names[names.length - 1][0];

  return firstInitial + lastInitial;
};

export default getInitials;
